import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../../services/PostData';
import {GetData} from '../../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table,
  Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery'
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import AppPage from '../../views/AppPage/';
const GLOBAL = require('../../Globals');

class MenuSetup extends Component {
	
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			cls : '',
			menufor : '',
			section : '',
			attdate : moment(),
			_message : '',
			alertClass :'',
			posts : [],
			chk_hw : '',
			chk_timetab : '',
			chk_pro : '',
			chk_abt : '',
			chk_evt : '',
			chk_ancmt : ''
			
		}
		this.onSubmit = this.onSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onTypeChange = this.onTypeChange.bind(this);
		this.onClickChange = this.onClickChange.bind(this);
	}
	
	
	
	onChange(e){
		
		this.setState({[e.target.name]:e.target.value});
		this.getdata();
		console.log(this.state);
	}
	
	onTypeChange(e){
		
		this.setState({menufor:e.target.value});
		this.getdata();
		console.log(this.state);
	}
	
	onClickChange(e){
		
		if(e.target.checked){
			
		  this.setState({[e.target.name]:1});
		
		}
		else {
			
			this.setState({[e.target.name]:0});
		}
	}
	
	
	
	onSubmit(e){
		e.preventDefault();
		 $("#showLoader").show();
		PostData('mobileapi/storemenusetup',this.state).then((result) => {
			 $("#showLoader").hide();
			let responseJson = result;
			if(responseJson.status == '1' ){
				/* this.setState({
					_message:'Attendance Added Successfully!..',
					alertClass:'alert alert-success',
				}); */
				alert('Settings Saved Successfully!..');
				document.getElementById("attform").reset();
				$("#attab").hide();
			}
			else{
				
				this.setState({
					_message:'Error!..',
					alertClass:'alert alert-danger',
				});
			}
		});
	}
	
	/** this function will be call when page loading **/
	componentWillMount(){
		
		this.getclass();
	}
	
	/** get Class **/
	getclass(){
		
		GetData('classs/getclass').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
				var cl = $("#clas").find("option:eq(1)").val();
				this.setState({
					cls : cl
				});
				$('#clas option').eq(1).prop('selected', true).trigger('change');
				this.getdata();
			}
		});
	}
	
	getdata(){
		
		var clss = $("#clas").val();
		$("#showLoader").show();
		GetData('mobileapi/getmenusetup/'+clss).then((result) => {
			$("#showLoader").hide();
			let res = result;
			if(res){
				
				this.setState({
					id :  res[0]['id'],
					chk_hw :  res[0]['homework'],
					chk_timetab : res[0]['timetable'],
					chk_pro : res[0]['profile'],
					chk_abt : res[0]['about'],
					chk_evt : res[0]['events'],
					chk_ancmt : res[0]['announcements']
				});
				if(this.state.chk_hw == 1){
					
					$("#chk_hw").prop("checked", true);
				}
				if(this.state.chk_hw == 0){
					$("#chk_hw").prop("checked", false);
				}
				
				if(this.state.chk_timetab == 1){
					
					$("#chk_timetab").prop("checked", true);
				}
				if(this.state.chk_timetab == 0){
					$("#chk_timetab").prop("checked", false);
				}
				
				if(this.state.chk_pro == 1){
					
					$("#chk_pro").prop("checked", true);
				}
				if(this.state.chk_pro == 0){
					$("#chk_pro").prop("checked", false);
				}
				if(this.state.chk_abt == 1){
					
					$("#chk_abt").prop("checked", true);
				}
				if(this.state.chk_abt == 0){
					$("#chk_abt").prop("checked", false);
				}
				if(this.state.chk_evt == 1){
					
					$("#chk_evt").prop("checked", true);
				}
				if(this.state.chk_evt == 0){
					$("#chk_evt").prop("checked", false);
				}
				if(this.state.chk_ancmt == 1){
					
					$("#chk_ancmt").prop("checked", true);
				}
				if(this.state.chk_ancmt == 0){
					$("#chk_ancmt").prop("checked", false);
				}
		
			
			}
			
		});
	}
	
	render() {
	 
		
	this.types = [
		{value : '', name : '-Select-'},
		{value : 'staff', name : 'Staff'},
		{value : 'student', name : 'Student'}
	];
		
		var items = this.state.posts;

		
		if(this.state.cls!=''){
			
			$("#attab").show();
			
		}
		else{
			
			$("#attab").hide();
		}
		
	  
	
	return (
		<div>
		  <AppPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			  <form action="" method="post" role="form" id="attform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>App Menu Setup</strong>
						</CardHeader>
						<CardBody>
							<Row>
							  <Col md="3">
								<FormGroup>
								  <Label htmlFor="name">Class <span className="text-danger">*</span></Label>
								  <select name="cls" onChange={this.onChange} className="form-control" id="clas" required> 
									<option value="">Select Class</option>
									{
										items.map(function (item) {
											return <option value={item.id }>{item.class}</option>;
										})
									}
								  </select>
								</FormGroup>
							  </Col>
							 
							</Row>
						</CardBody>
					</Card>
				  </Col>
				  <Col md="12" id="attab">
					<Card>
					  <CardHeader className="card-header-inner">
						<strong>Staff</strong>
					  </CardHeader>
					  <CardBody>
						<Row>
						  <Col md="12">
							<Table responsive bordered striped id="atttable">
							  <thead>
								<tr>
									<th>About</th>
									<th>Events</th>
									<th>Announcements</th>
									<th>HomeWork</th>
									<th>Timetable</th>
									<th>Profile</th>
								</tr>
							  </thead>
							  <tbody>
									<tr>
										<td><input type="checkbox" id="chk_abt"  name="chk_abt" onClick={this.onClickChange} /></td>
										<td><input type="checkbox" id="chk_evt"   name="chk_evt" onClick={this.onClickChange} /></td>
										<td><input type="checkbox" id="chk_ancmt"  name="chk_ancmt" onClick={this.onClickChange} /></td>
										<td><input type="checkbox" id="chk_hw"  name="chk_hw" onClick={this.onClickChange} /></td>
										<td><input type="checkbox" id="chk_timetab"   name="chk_timetab" onClick={this.onClickChange} /></td>
										<td><input type="checkbox" id="chk_pro"   name="chk_pro" onClick={this.onClickChange} /></td>
									</tr>
							  </tbody>
							</Table>
						  </Col>
						</Row>
					  </CardBody>
					  <CardFooter>
						<Button type="submit" size="sm" color="primary" className="btn-right"><i className="fa fa-dot-circle-o"></i> Submit</Button>
					  </CardFooter>
					</Card>
				  </Col>
				</Row>
			  </form>
			</div>
		</div>
	)
  }
}

export default MenuSetup;


// WEBPACK FOOTER //
// ./src/app/MenuSetup/MenuSetup.js